import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import HomeAppBar from "../../components/HomeAppBar/HomeAppBar";
import { useTheme } from "../../contexts/ThemeContext";
import EmailTab from "../../components/EmailTab/EmailTab";

export default function Emails({ theme, user, permissionConfig }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const containerStyle = { ...theme.container };
    containerStyle.p = "0px !important";
    containerStyle.m = "0px !important";
    containerStyle.pt = "65px !important";

    return (
        <>
            <Container sx={containerStyle}>
                <HomeAppBar
                    theme={theme}
                    selectedPage="emails"
                    user={user}
                    permissionConfig={permissionConfig}
                />
                <Box sx={{ p: 3 }}>
                    <EmailTab
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                    />
                </Box>
            </Container>
        </>
    );
}
